const phoneRegex = /(\+?\d{1,3}[\s\-./]?)(\d{2}[\s\-./]?){4}/g;
const emailRegex = /[\w-]+@([\w-]+\.)+[\w-]+/g;

/**
 * Obsfuse les numéros de téléphones et les adresses e-mails.
 * @param {string} str - La chaîne de caractères à obsfusquer.
 */
export default function stringObsfuscateContact(str) {
  return str
    .replace(phoneRegex, "•• •• •• •• ••")
    .replace(emailRegex, "•••••@••••••");
}
